import {
    GET_MOMENTM_PAYER_SUCCESS,
    GET_PAYER_RATES_SUCCESS,
    GET_PAYER_SINGLE_SUCCESS,
    GET_PAYERS_SUCCESS
} from "./payer.types";

const initialState = {
    payersList: null,
    payerSingle: null,
    payersRatesList: null,
    momentm: null
};

export const payerReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PAYERS_SUCCESS:
            return {
                ...state,
                payersList: action.payload,
            };

        case GET_PAYER_SINGLE_SUCCESS:
            return {
                ...state,
                payerSingle: action.payload,
            };

        case GET_PAYER_RATES_SUCCESS:
            return {
                ...state,
                payersRatesList: action.payload,
            };

            case GET_MOMENTM_PAYER_SUCCESS:
            return {
                ...state,
                momentm: action.payload,
            };

        default:
            return state;
    }
};
